import { RichTextBlock } from 'prismic-reactjs';
import gql from 'graphql-tag';
import { IImage, ILink } from 'utils/types';
import { IBaseSlice, SliceTypes } from '..';
import { PrismicImage, PrismicLink } from '../../utils/PrismicTypes';
import { parser } from '../../utils/parsers';

export interface IColumnSection extends IBaseSlice {
  tagline: string;
  title: string;
  image: IImage;
  numbered: boolean;
  color: string;
  items: Array<{
    title: string;
    text: RichTextBlock[];
    link: ILink;
    label: string;
    icon: string;
  }>;
}

export const fragment = (name: string, type: string, fragmentName: string) => gql`
  fragment ${fragmentName || name} on ${type} {
    ... on ${type}${name} {
      type
      primary {
        slice_tagline
        slice_title
        slice_image
        slice_numbered
        slice_color
      }
      fields {
        item_title
        item_text
        item_link { ...Link }
        item_label
        item_icon
      }
    }
  }
`;

type Props = {
  primary: {
    slice_tagline: RichTextBlock[];
    slice_title: RichTextBlock[];
    slice_image: PrismicImage;
    slice_numbered: boolean;
    slice_color: string;
  };
  fields: Array<{
    item_title: RichTextBlock[];
    item_text: RichTextBlock[];
    item_link: PrismicLink;
    item_label: RichTextBlock[];
    item_icon: string;
  }>;
};

export const parse = (slice: Props, redirects?): IColumnSection => ({
  type: SliceTypes.ColumnSection,
  tagline: parser.string(slice.primary.slice_tagline),
  title: parser.string(slice.primary.slice_title),
  image: parser.image(slice.primary.slice_image),
  numbered: slice.primary.slice_numbered,
  color: parser.string(slice.primary.slice_color),
  items: slice.fields.map((field) => ({
    title: parser.string(field.item_title),
    text: parser.richText(field.item_text, redirects),
    link: parser.link(field.item_link, redirects),
    label: parser.string(field.item_label),
    icon: parser.string(field.item_icon),
  })),
});
